<template>
  <div class="tipLayer" v-show="show" @click.stop="hide">
    <div class="tipBox">
      <div :class="{'tip-main':true,left:index===0,center:index===1}">
      <span
              v-for="(item, i) in mes"
              v-bind:key="i"
              @click="gotoPage(item)"
              :class="{'active-click':label === item.label}"
      >
        {{ item.label }}
      </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tooltip",
  props: ["menuObj"],
  data() {
    return {
      show: false,
      label:'',
      mes: [],
      index:0
    };
  },
  watch: {
    "menuObj.place"(v) {
      if(v===''){
        return
      }
      this.show = this.menuObj.isShow;
      this.mes = this.menuObj.menus;
      this.index = v
    }
  },
  methods: {
    gotoPage(m) {
      this.label = m.label
      const _push = 'moudel' in m ?{ path: m.uri, query:{moudel:m.moudel} }:{ path: m.uri }
      this.$router.push(_push);
      this.$emit('feelback');
    },
    hide() {
      this.show = false;
      this.$emit('feelback');
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/index";
.tipLayer{
  position: absolute;
  height: 92%;
  width: 100%;
  background-color: rgba(0,0,0,0);
  top: 0;
  left: 0;
  .tipBox {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    height: 100%;
    width: 100%;
    .tip-main {
      display: flex;
      flex-direction: column;
      margin-bottom: px2rem(5);
      border: 2px solid rgb(70,73,75);
      border-radius: 8px;
      box-shadow: 3px 1px 6px 5px #1d1f23;;
      background-color: rgb(40,44,49);
      position: relative;
      span {
        width: px2rem(70);
        font-size: px2rem(14);
        padding: 1rem;
        color: #a0a2a4;
        text-align: center;
        white-space: nowrap;
        border-bottom: 1px solid rgb(49, 53, 57);
      }
      .active-click{
        color: #e02c00 !important;
      }
    }
    .tip-main::after {
      position: absolute;
      content: '';
      width: 0px;
      height: 0px;
      left: px2rem(45);
      bottom: px2rem(-14);
      //border-top: px2rem(10) solid rgb(40,44,49);;
      border: px2rem(6) solid;
      border-color:rgb(70,73,75) transparent transparent transparent ;
    }
    .left{
      margin-left: 4%;
    }
    .center{
      margin-left: 36%;
    }
  }
}
</style>
